import type { FormField } from './types';

/** Parses the subset of an Image property's configJson this feature cares about. */
function imageConfig(configJson: string): { source: string; collectionItem: string } {
  try {
    const parsed = JSON.parse(configJson || '{}') as { source?: unknown; collectionItem?: unknown };
    return {
      source: typeof parsed.source === 'string' ? parsed.source : 'upload',
      collectionItem: typeof parsed.collectionItem === 'string' ? parsed.collectionItem : ''
    };
  } catch {
    return { source: 'upload', collectionItem: '' };
  }
}

/**
 * An Image bound to `source: collection` with no pinned `collectionItem` is "open": the
 * consultant picks one item per document, so its `resolvedDefault` (the reference KEY, not
 * an item id) must never be treated as a real value — neither pre-filled into wizard state
 * nor read back as "already chosen". Shared by `useWizard` (must not seed it) and
 * `PropertyField`/`ImageCollectionPicker` (must render the picker), so the two can't disagree.
 */
export function isOpenCollectionImage(field: Pick<FormField, 'propertyType' | 'configJson'>): boolean {
  if (field.propertyType !== 'Image') return false;
  const { source, collectionItem } = imageConfig(field.configJson);
  return source === 'collection' && collectionItem === '';
}
